// this is the localization package for translating languages on the frontend
// @ts-ignore
import i18next from "i18next";

//@ts-ignore support pulling translations from the backend.
import Backend from 'i18next-xhr-backend';

//@ts-ignore cache http results as a result of translations
import Cache from 'i18next-localstorage-cache';

//@ts-ignore detect the user preferred language in the browser.
import LanguageDetector from 'i18next-browser-languagedetector';

export const SUPPORTED_LANGUAGES = ["en", "de", "fr", "es"] as const;

type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

export const resolveLanguage = (language?: string | null): SupportedLanguage => {
	const normalized = (language || "").toLowerCase().split("-")[0];
	return SUPPORTED_LANGUAGES.includes(normalized as SupportedLanguage)
		? (normalized as SupportedLanguage)
		: "en";
};

export const getPreferredLanguage = (): SupportedLanguage => {
	return resolveLanguage(window.localStorage.getItem("i18nextLng") || navigator.language);
};

export default () => {
	const language = getPreferredLanguage();
	window.localStorage.setItem("i18nextLng", language);

	return i18next
		.use(Backend)
		.use(Cache)
		.use(LanguageDetector)
		.init({
			lng: language,
			fallbackLng: "en",
			supportedLngs: [...SUPPORTED_LANGUAGES],
			nonExplicitSupportedLngs: true,
			load: "languageOnly",
			debug: false,
			preload: [...SUPPORTED_LANGUAGES],
			backend: {
				loadPath: "/api/locales/{{lng}}",
				crossDomain: true,
				withCredentials: false,
			}
		});
}
